export class MetadataSearchRequestModel {
    DocumentTypeId: number;
    forCustomPage: boolean;
    MetadataSearch: Array<MetadataSearchModel>;
}

export class MetadataSearchModel {
    DocumentTypeMetadataId: number;
    FieldName: string;
    FieldType: string;
    FieldValueFrom: string;
    FieldValueTo: string;
}


export class DocumentPublicMetadataRequestModel {
    DocumentTypeInboxId: number;
    DocumentTypeId: number;
    IsPublic: boolean;
    UserId: number;
    DocumentTypeMetadataId: number;
}

export class MoveDocumentsRequest {
    DocumentIds: number[];
    SourceDocumentTypeId: number;
    TargetDocumentTypeId: number;
    CompanyId: number;
    DocumentCabinetId: number;
    UserId: number;
}

export class MoveDocumentsResponse {
    IsSuccess: boolean;
    Message: string;
    MovedDocumentsCount: number;
    TargetDocumentTypeName: string;
    FailedMoves: string[];
}

export class BulkRetryOcrRequest {
    DocumentIds: number[];
    UserId: number;
}
